import __var_0__ from '@stdlib/constants/math/float16-min-safe-integer';
import __var_1__ from '@stdlib/constants/math/float32-min-safe-integer';
import __var_2__ from '@stdlib/constants/math/float64-min-safe-integer';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var FLOAT16 = __var_0__;
var FLOAT32 = __var_1__;
var FLOAT64 = __var_2__;


// MAIN //

/**
* Returns the minimum safe integer capable of being represented by a numeric real type.
*
* @param {string} dtype - numeric type
* @throws {TypeError} must provide a recognized numeric type
* @returns {integer} minimum safe integer
*
* @example
* var m = safeintmin( 'float64' );
* // returns -9007199254740991
*
* @example
* var m = safeintmin( 'float16' );
* // returns -2047
*
* @example
* var m = safeintmin( 'float32' );
* // returns -16777215
*/
function safeintmin( dtype ) {
	switch ( dtype ) {
	case 'float64':
		return FLOAT64;
	case 'float32':
		return FLOAT32;
	case 'float16':
		return FLOAT16;
	default:
		throw new TypeError( 'invalid argument. Must provide a recognized type. Value: `'+dtype+'`.' );
	}
}


// EXPORTS //
export default safeintmin;
